/**
 * This enum represents all tracked actions for analytics events.
 */
export enum EventAction {
	GTM_PURCHASE_ACTION = 'purchase'
}
